export type DateTimeValue =
  | { toDate(): Date }
  | string
  | Date
  | null
  | undefined;

export const toDate = (value: DateTimeValue | unknown): Date | null => {
  if (!value) return null;
  if (value instanceof Date)
    return Number.isNaN(value.getTime()) ? null : value;
  if (typeof value === 'string') {
    const parsed = new Date(value);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
  }
  if (
    typeof value === 'object' &&
    'toDate' in value &&
    typeof (value as { toDate: unknown }).toDate === 'function'
  ) {
    const parsed = (value as { toDate(): Date }).toDate();
    return parsed instanceof Date && !Number.isNaN(parsed.getTime())
      ? parsed
      : null;
  }
  return null;
};

const pad = (value: number) => String(value).padStart(2, '0');

const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const formatDayMonthTime = (value: DateTimeValue | unknown) => {
  const date = toDate(value);
  if (!date) return '—';
  return `${date.getDate()} ${MONTHS[date.getMonth()]} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
};

export const formatDotDate = (value: DateTimeValue | unknown) => {
  const date = toDate(value);
  if (!date) return '—';
  return `${pad(date.getDate())}.${pad(date.getMonth() + 1)}.${date.getFullYear()}`;
};

export const formatDateTime = (value: DateTimeValue | unknown) => {
  const date = toDate(value);
  if (!date) return '—';
  return `${formatDotDate(date)} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
};
